import React, { Component } from "react";
import "./UploadValidate.css";

// ─── S2Card – file result card with open/close toggle ─────────────────────────
class S2Card extends Component {
  constructor(props) {
    super(props);
    this.state = { open: props.f.status !== "OK" };
  }

  fmtType(t) {
    var map = {
      DATA_TYPE: "Data Type",
      FORMAT: "Format",
      MISSING_COLUMN: "Missing Col",
      MISSING_FILE: "Missing File",
      SYSTEM_ERROR: "System",
    };
    return map[t] || t || "Unknown";
  }

  renderErrorTable(errors) {
    var self = this;
    return (
      <div className="uv-tbl-wrap">
        <table>
          <thead>
            <tr>
              <th>Row</th>
              <th>Column</th>
              <th>Value</th>
              <th>Reason</th>
              <th>Error Type</th>
            </tr>
          </thead>
          <tbody>
            {errors.map(function (e, i) {
              return (
                <tr key={i}>
                  <td className="uv-td-row">{e.row != null ? e.row : "—"}</td>
                  <td className="uv-td-col">{e.column || "—"}</td>
                  <td className="uv-td-val">
                    {String(e.value != null ? e.value : "—")}
                  </td>
                  <td className="uv-td-rsn">{e.reason || "—"}</td>
                  <td className="uv-td-type">
                    <span className={"uv-chip uv-chip-" + (e.errorType || "")}>
                      {self.fmtType(e.errorType)}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    var f = this.props.f;
    var idx = this.props.idx;
    var open = this.state.open;
    var scMap = {
      OK: "uv-sc-ok",
      ERROR: "uv-sc-error",
      MISSING: "uv-sc-missing",
    };
    var bdgMap = {
      OK: "uv-bdg-ok",
      ERROR: "uv-bdg-error",
      MISSING: "uv-bdg-missing",
    };
    var sc = scMap[f.status] || "";
    var bdg = bdgMap[f.status] || "";
    var lbl =
      f.status === "OK"
        ? "✓ Valid"
        : f.status === "MISSING"
          ? "⚠ Missing"
          : "✗ " + f.errorCount + " error(s)";

    return (
      <div
        className={"uv-s2-card " + sc + (open ? " uv-open" : "")}
        style={{ animationDelay: idx * 0.07 + "s" }}
      >
        <div
          className="uv-s2-card-header"
          onClick={() => this.setState({ open: !open })}
        >
          <span className="uv-s2-card-dot"></span>
          <span className="uv-s2-card-name">{f.fileName}.csv</span>
          <div className="uv-s2-card-meta">
            <span>📄 {f.totalRows.toLocaleString()} rows</span>
            <span>
              🚨 {f.errorCount} error{f.errorCount !== 1 ? "s" : ""}
            </span>
          </div>
          <span className={"uv-badge " + bdg}>{lbl}</span>
          <span className="uv-s2-card-chev">›</span>
        </div>
        {open && (
          <div className="uv-s2-card-body">
            {f.status === "OK" ? (
              <div className="uv-s2-no-err">
                ✅ All data in this file is valid.
              </div>
            ) : f.errors && f.errors.length ? (
              this.renderErrorTable(f.errors)
            ) : (
              <div className="uv-s2-no-err">No detail available.</div>
            )}
          </div>
        )}
      </div>
    );
  }
}

// ─── UploadValidate – main component ─────────────────────────────────────────
class UploadValidate extends Component {
  constructor(props) {
    super(props);
    var params = new URLSearchParams(
      props.location ? props.location.search : "",
    );
    this.cfg = {
      apiBase: params.get("apiBase") || "",
      token: params.get("token") || "",
      reportDate: params.get("reportDate") || "",
      reportName: params.get("reportName") || "",
      component: params.get("component") || "RAROC",
    };
    this.state = {
      step: 1,
      totalFiles: 0,
      processedFiles: 0,
      percent: 0,
      currentFile: "",
      currentStatus: "idle",
      fileResults: [],
      liveCount: 0,
      panelVisible: false,
      liveTableVisible: false,
      screen2Visible: false,
      doneData: null,
      s2Search: "",
      s2Status: "",
      toasts: [],
      // Step 3: calculation
      calcPercent: 0,
      calcStatus: "idle",
      calcError: null,
      // Step 4: done
      reportUrl: null,
    };
    this._es = null;
    this._toastId = 0;
    this._canvasRef = null;
    this._confetti = null;
    this._calcTimer = null;
    this._fakePercent = 0;
  }

  componentDidMount() {
    this.startValidation();
  }

  componentWillUnmount() {
    if (this._es) {
      this._es.close();
      this._es = null;
    }
    if (this._confetti) {
      cancelAnimationFrame(this._confetti);
    }
    if (this._calcTimer) {
      clearInterval(this._calcTimer);
      this._calcTimer = null;
    }
  }

  // ─── SSE Validation ────────────────────────────────────────────────────────
  startValidation() {
    if (this._es) {
      this._es.close();
      this._es = null;
    }
    var cfg = this.cfg;
    this.setState({
      step: 1,
      totalFiles: 0,
      processedFiles: 0,
      percent: 0,
      currentFile: "",
      currentStatus: "idle",
      fileResults: [],
      liveCount: 0,
      panelVisible: true,
      liveTableVisible: false,
      screen2Visible: false,
      doneData: null,
    });

    var url =
      cfg.apiBase +
      "/validate-data-stream" +
      "?reportDate=" +
      encodeURIComponent(cfg.reportDate) +
      "&reportName=" +
      encodeURIComponent(cfg.reportName) +
      "&component=" +
      encodeURIComponent(cfg.component) +
      (cfg.token ? "&jwt=" + encodeURIComponent(cfg.token) : "");

    var self = this;
    var es = new EventSource(url);
    this._es = es;

    es.addEventListener("start", function (e) {
      var d = JSON.parse(e.data);
      self.setState({ totalFiles: d.total });
      self.addToast(
        "info",
        "🔍 Validation started",
        d.total + " files will be checked",
      );
    });

    es.addEventListener("progress", function (e) {
      var d = JSON.parse(e.data);
      self.setState({
        percent: d.percent,
        currentFile: d.currentFile,
        currentStatus: d.status,
        processedFiles: d.processed,
        totalFiles: d.total,
      });
    });

    es.addEventListener("file", function (e) {
      var f = JSON.parse(e.data);
      self.setState(function (prev) {
        return {
          fileResults: prev.fileResults.concat([f]),
          liveCount: prev.liveCount + 1,
          liveTableVisible: true,
        };
      });
      if (f.status === "ERROR")
        self.addToast(
          "error",
          "✗ " + f.fileName,
          f.errorCount + " error(s) found",
        );
      else if (f.status === "MISSING")
        self.addToast("warn", "⚠ " + f.fileName, "File not found");
      else
        self.addToast(
          "ok",
          "✓ " + f.fileName,
          f.totalRows.toLocaleString() + " rows — valid",
        );
    });

    es.addEventListener("done", function (e) {
      var d = JSON.parse(e.data);
      es.close();
      self._es = null;
      self.setState({ step: 2, doneData: d });
      setTimeout(function () {
        self.setState({ screen2Visible: true });
      }, 100);
      if (d.totalErrors === 0) {
        setTimeout(function () {
          self.launchConfetti();
        }, 600);
        setTimeout(function () {
          self.startCalculation();
        }, 2000);
      }
    });

    es.onerror = function () {
      if (es.readyState === EventSource.CLOSED) return;
      self.addToast(
        "error",
        "⚠ Connection lost",
        "Stream interrupted. Try re-validating.",
      );
      es.close();
      self._es = null;
    };
  }

  // ─── Calculation ────────────────────────────────────────────────────────────
  startCalculation() {
    if (this._calcTimer) {
      clearInterval(this._calcTimer);
      this._calcTimer = null;
    }
    var self = this;
    var cfg = this.cfg;
    this._fakePercent = 3;
    this.setState({
      step: 3,
      calcPercent: 3,
      calcStatus: "running",
      calcError: null,
    });
    this.addToast(
      "info",
      "⚙️ Calculation started",
      "Processing " + cfg.component + " data…",
      5000,
    );

    var calcBase = cfg.apiBase.replace(/\/api\/file$/, "");
    fetch(calcBase + "/api/calculator/" + cfg.component.toLowerCase(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + cfg.token,
      },
      body: JSON.stringify({
        report_date: cfg.reportDate,
        report_name: cfg.reportName,
      }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (res) {
        if (
          res &&
          (res.ErrorCode === "PENDING_BATCH_PROCESSING" || res.Success)
        ) {
          self.pollCalculation();
        } else {
          self.setState({
            step: 3,
            calcStatus: "error",
            calcError: (res && res.ErrorCode) || "Failed to start calculation",
          });
          self.addToast(
            "error",
            "❌ Calculation failed",
            (res && res.ErrorCode) || "Unknown error",
          );
        }
      })
      .catch(function (err) {
        self.setState({
          step: 3,
          calcStatus: "error",
          calcError: "Network error: " + err.message,
        });
        self.addToast("error", "❌ Network error", err.message);
      });
  }

  pollCalculation() {
    var self = this;
    var cfg = this.cfg;
    this._calcTimer = setInterval(function () {
      // Advance fake progress
      var fp = self._fakePercent;
      var inc = Math.random() * 7 + 2;
      fp = Math.min(fp + inc, 94);
      self._fakePercent = fp;
      self.setState({ calcPercent: Math.round(fp) });

      fetch(
        cfg.apiBase +
          "/batch-result?report_date=" +
          encodeURIComponent(cfg.reportDate) +
          "&report_name=" +
          encodeURIComponent(cfg.reportName),
        {
          headers: { Authorization: "Bearer " + cfg.token },
        },
      )
        .then(function (r) {
          return r.json();
        })
        .then(function (res) {
          if (
            !res ||
            res.ErrorCode === "PENDING_BATCH_PROCESSING" ||
            res.ErrorCode === "BATCH_EMPTY"
          ) {
            return; // still in progress
          }
          clearInterval(self._calcTimer);
          self._calcTimer = null;
          self.handleCalcDone(res);
        })
        .catch(function () {
          // ignore poll errors, keep trying
        });
    }, 3000);
  }

  handleCalcDone(res) {
    var cfg = this.cfg;
    var comp = (cfg.component || "").toUpperCase();
    var reportUrl;
    if (comp === "RAROC")
      reportUrl =
        "/#/raroc/reports?reportName=" + encodeURIComponent(cfg.reportName);
    else if (comp === "PRICING")
      reportUrl =
        "/#/pricing/processing?reportName=" +
        encodeURIComponent(cfg.reportName);
    else reportUrl = null;
    this.setState({
      step: 4,
      calcPercent: 100,
      calcStatus: "done",
      reportUrl: reportUrl,
    });
    this.addToast("ok", "✅ Calculation complete", "Report is ready", 8000);
    setTimeout(function () {
      var canvas = document.querySelector(".uv-root canvas");
      if (canvas) {
        canvas.style.display = "block";
      }
    }, 0);
    var self = this;
    setTimeout(function () {
      self.launchConfetti();
    }, 300);
  }

  doRevalidate() {
    this.setState({ screen2Visible: false });
    var self = this;
    setTimeout(function () {
      self.startValidation();
    }, 680);
  }

  // ─── Toasts ────────────────────────────────────────────────────────────────
  addToast(type, title, msg, ttl) {
    if (ttl === undefined) ttl = 4000;
    var id = ++this._toastId;
    this.setState(function (prev) {
      var next = prev.toasts
        .slice(-5)
        .concat([{ id: id, type: type, title: title, msg: msg }]);
      return { toasts: next };
    });
    if (ttl > 0) {
      var self = this;
      setTimeout(function () {
        self.removeToast(id);
      }, ttl);
    }
  }

  removeToast(id) {
    this.setState(function (prev) {
      return {
        toasts: prev.toasts.filter(function (t) {
          return t.id !== id;
        }),
      };
    });
  }

  // ─── Confetti ──────────────────────────────────────────────────────────────
  launchConfetti() {
    var canvas = this._canvasRef;
    if (!canvas) return;
    canvas.style.display = "block";
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    var ctx = canvas.getContext("2d");
    var COLORS = [
      "#FFE600",
      "#168736",
      "#2563EB",
      "#E67E22",
      "#ffffff",
      "#2E2E38",
      "#FF6B6B",
    ];
    var pieces = [];
    for (var i = 0; i < 140; i++) {
      pieces.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height - canvas.height,
        r: Math.random() * 7 + 2,
        color: COLORS[Math.floor(Math.random() * COLORS.length)],
        angle: Math.random() * Math.PI * 2,
        vel: Math.random() * 2.5 + 1.5,
        shape: Math.random() > 0.5 ? "rect" : "circle",
      });
    }
    var frameCount = 0;
    var self = this;
    function draw() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      pieces.forEach(function (p) {
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.angle);
        ctx.fillStyle = p.color;
        if (p.shape === "rect") {
          ctx.fillRect(-p.r, -p.r / 2, p.r * 2, p.r);
        } else {
          ctx.beginPath();
          ctx.arc(0, 0, p.r / 2, 0, Math.PI * 2);
          ctx.fill();
        }
        ctx.restore();
        p.y += p.vel;
        p.angle += 0.08;
        p.x += Math.sin(p.angle) * 1.2;
      });
      frameCount++;
      if (frameCount < 200) {
        self._confetti = requestAnimationFrame(draw);
      } else {
        canvas.style.display = "none";
        ctx.clearRect(0, 0, canvas.width, canvas.height);
      }
    }
    self._confetti = requestAnimationFrame(draw);
  }

  // ─── Export CSV ────────────────────────────────────────────────────────────
  exportCSV() {
    var fileResults = this.state.fileResults;
    var cfg = this.cfg;
    var rows = [["File", "Row", "Column", "Value", "Reason", "ErrorType"]];
    fileResults.forEach(function (f) {
      (f.errors || []).forEach(function (e) {
        rows.push([
          f.fileName,
          e.row != null ? e.row : "",
          e.column || "",
          e.value != null ? e.value : "",
          e.reason || "",
          e.errorType || "",
        ]);
      });
    });
    var csv = rows
      .map(function (r) {
        return r
          .map(function (c) {
            return '"' + String(c).replace(/"/g, '""') + '"';
          })
          .join(",");
      })
      .join("\n");
    var a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
    a.download =
      "errors-" +
      cfg.component +
      "-" +
      cfg.reportDate.replace(/\//g, "-") +
      ".csv";
    a.click();
  }

  // ─── Render helpers ────────────────────────────────────────────────────────
  renderToasts() {
    var self = this;
    var icons = { ok: "✅", error: "❌", warn: "⚠️", info: "ℹ️" };
    return (
      <div className="uv-toast-container">
        {this.state.toasts.map(function (t) {
          return (
            <div key={t.id} className={"uv-toast uv-toast-" + t.type}>
              <span className="uv-toast-icon">{icons[t.type] || "•"}</span>
              <div>
                <div className="uv-toast-title">{t.title}</div>
                {t.msg && <div className="uv-toast-msg">{t.msg}</div>}
              </div>
              <button
                className="uv-toast-close"
                onClick={function () {
                  self.removeToast(t.id);
                }}
              >
                ×
              </button>
            </div>
          );
        })}
      </div>
    );
  }

  renderScreen1() {
    var s = this.state;
    var cfg = this.cfg;
    var C = 345.4;
    var offset = C - (s.percent / 100) * C;

    return (
      <div className="uv-screen-validate">
        <div className="uv-page">
          {/* Info panel */}
          <div className="uv-panel">
            <div className="uv-panel-header">
              <div className="uv-panel-icon uv-pi-yellow">📋</div>
              <div>
                <div className="uv-panel-title">Validation Run</div>
                <div className="uv-panel-desc">
                  Checking uploaded files against schema rules
                </div>
              </div>
            </div>
            <div className="uv-panel-body">
              <div className="uv-info-chips">
                <div className="uv-info-chip">
                  <span className="uv-chip-label">Component</span>
                  <span className="uv-chip-value">{cfg.component}</span>
                </div>
                <div className="uv-info-chip">
                  <span className="uv-chip-label">Report Date</span>
                  <span className="uv-chip-value">{cfg.reportDate}</span>
                </div>
                <div className="uv-info-chip">
                  <span className="uv-chip-label">Report Name</span>
                  <span className="uv-chip-value">{cfg.reportName}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Progress panel */}
          {s.panelVisible && (
            <div className="uv-panel">
              <div className="uv-panel-header">
                <div className="uv-panel-icon uv-pi-blue">🔍</div>
                <div>
                  <div className="uv-panel-title">
                    {s.step > 1 ? "Validation complete" : "Validating files…"}
                  </div>
                  <div className="uv-panel-desc">
                    {cfg.component} · {cfg.reportDate} · {s.totalFiles} files to
                    check
                  </div>
                </div>
                <div style={{ marginLeft: "auto" }}>
                  <span className="uv-badge uv-badge-info">
                    Step {s.step}/2
                  </span>
                </div>
              </div>
              <div className="uv-progress-wrap">
                {/* Ring */}
                <div className="uv-ring-wrap">
                  <svg
                    width="120"
                    height="120"
                    viewBox="0 0 120 120"
                    style={{ transform: "rotate(-90deg)" }}
                  >
                    <circle className="uv-ring-bg" cx="60" cy="60" r="55" />
                    <circle
                      className={
                        "uv-ring-fill" +
                        (s.percent === 100
                          ? s.doneData && s.doneData.totalErrors > 0
                            ? " uv-errored"
                            : " uv-done"
                          : "")
                      }
                      cx="60"
                      cy="60"
                      r="55"
                      style={{ strokeDashoffset: offset }}
                    />
                  </svg>
                  <div className="uv-ring-center">
                    <span className="uv-ring-pct">{s.percent}%</span>
                    <span className="uv-ring-label">DONE</span>
                  </div>
                </div>
                {/* Bar */}
                <div className="uv-bar-wrap">
                  <div className="uv-bar-current">
                    {s.currentStatus === "processing" && (
                      <span className="uv-dot-ping"></span>
                    )}
                    <span>
                      {s.currentStatus === "processing"
                        ? "Checking " + s.currentFile + ".csv…"
                        : s.percent === 0
                          ? "Initializing…"
                          : "Processing…"}
                    </span>
                  </div>
                  <div className="uv-bar-track">
                    <div
                      className={
                        "uv-bar-fill" + (s.percent < 100 ? " uv-running" : "")
                      }
                      style={{ width: s.percent + "%" }}
                    ></div>
                  </div>
                  <div className="uv-bar-info">
                    <span>
                      {s.processedFiles} / {s.totalFiles}
                    </span>
                  </div>
                </div>
              </div>

              {/* Live file list */}
              {s.liveTableVisible && (
                <div className="uv-live-table-wrap">
                  <div className="uv-live-table-head">
                    <span>
                      {s.liveCount} file{s.liveCount !== 1 ? "s" : ""} checked
                    </span>
                  </div>
                  <ul className="uv-lt-list">
                    {s.fileResults.map(function (f, idx) {
                      var scMap = {
                        OK: "uv-lst-ok",
                        ERROR: "uv-lst-error",
                        MISSING: "uv-lst-missing",
                      };
                      var sc = scMap[f.status] || "uv-lst-loading";
                      var icon =
                        f.status === "OK"
                          ? "✓"
                          : f.status === "MISSING"
                            ? "!"
                            : "✗";
                      var ec =
                        f.status === "ERROR"
                          ? "uv-ltec-error"
                          : f.status === "MISSING"
                            ? "uv-ltec-warn"
                            : "uv-ltec-ok";
                      var errTxt =
                        f.status === "MISSING"
                          ? "Missing"
                          : f.errorCount === 0
                            ? "—"
                            : f.errorCount +
                              " error" +
                              (f.errorCount > 1 ? "s" : "");
                      var firstErr =
                        f.errors && f.errors.length ? f.errors[0] : null;
                      var preview = firstErr
                        ? (
                            (firstErr.column ? firstErr.column + ": " : "") +
                            (firstErr.reason || "")
                          ).slice(0, 80)
                        : f.status === "MISSING"
                          ? "File not found"
                          : "All rows valid";
                      return (
                        <li key={idx} className="uv-lt-item">
                          <div
                            className="uv-lt-row"
                            style={{ animationDelay: idx * 0.04 + "s" }}
                          >
                            <div className={"uv-lt-status " + sc}>{icon}</div>
                            <span className="uv-lt-name">{f.fileName}.csv</span>
                            <span className="uv-lt-rows">
                              {f.totalRows.toLocaleString()} rows
                            </span>
                            <span className={"uv-lt-errct " + ec}>
                              {errTxt}
                            </span>
                            <span className="uv-lt-preview">{preview}</span>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }

  renderScreen2() {
    var self = this;
    var s = this.state;
    var cfg = this.cfg;
    if (!s.doneData) return null;
    var d = s.doneData;
    var isOK = d.totalErrors === 0;
    var heroGrad = isOK
      ? "linear-gradient(135deg, #0D3B22 0%, #1B5E35 55%, #1A3A4A 100%)"
      : "linear-gradient(135deg, #3B0A0A 0%, #6B1818 55%, #3B2010 100%)";

    // Apply filters
    var search = s.s2Search.toLowerCase();
    var filtered = s.fileResults.filter(function (f) {
      if (s.s2Status && f.status !== s.s2Status) return false;
      if (!search) return true;
      if (f.fileName.toLowerCase().indexOf(search) !== -1) return true;
      return (f.errors || []).some(function (e) {
        return (
          (e.column || "").toLowerCase().indexOf(search) !== -1 ||
          String(e.value || "")
            .toLowerCase()
            .indexOf(search) !== -1 ||
          (e.reason || "").toLowerCase().indexOf(search) !== -1
        );
      });
    });

    return (
      <div
        className={
          "uv-screen-results" + (s.screen2Visible ? " uv-visible" : "")
        }
      >
        {/* Hero */}
        <div className="uv-s2-hero" style={{ background: heroGrad }}>
          <div className="uv-s2-hero-inner">
            <div className="uv-s2-icon">{isOK ? "✅" : "❌"}</div>
            <div>
              <div className="uv-s2-title">
                {isOK
                  ? "All files passed validation"
                  : d.totalErrors +
                    " error" +
                    (d.totalErrors > 1 ? "s" : "") +
                    " found"}
              </div>
              <div className="uv-s2-sub">
                {cfg.component} · {cfg.reportDate} · {cfg.reportName}
              </div>
            </div>
            <span
              className={
                "uv-s2-hero-badge " +
                (isOK ? "uv-s2-badge-ok" : "uv-s2-badge-err")
              }
            >
              {isOK
                ? "✓ Ready to proceed to calculation"
                : (d.summary
                    ? (d.summary.error || 0) + (d.summary.missing || 0)
                    : 0) + " file(s) need attention"}
            </span>
          </div>
        </div>

        <div className="uv-page">
          {/* Stats */}
          <div className="uv-s2-stats">
            <div className="uv-s2-stat">
              <div
                className={
                  "uv-s2-stat-n uv-s2-stat-" +
                  (d.totalErrors > 0 ? "err" : "ok")
                }
              >
                {d.totalErrors}
              </div>
              <div className="uv-s2-stat-l">Total Errors</div>
            </div>
            <div className="uv-s2-stat">
              <div className="uv-s2-stat-n uv-s2-stat-ok">
                {d.summary ? d.summary.ok : 0}
              </div>
              <div className="uv-s2-stat-l">Valid Files</div>
            </div>
            <div className="uv-s2-stat">
              <div className="uv-s2-stat-n uv-s2-stat-err">
                {d.summary ? d.summary.error : 0}
              </div>
              <div className="uv-s2-stat-l">Files with Errors</div>
            </div>
            <div className="uv-s2-stat">
              <div className="uv-s2-stat-n uv-s2-stat-warn">
                {d.summary ? d.summary.missing : 0}
              </div>
              <div className="uv-s2-stat-l">Missing Files</div>
            </div>
          </div>

          {/* Toolbar */}
          <div className="uv-s2-toolbar">
            <input
              className="uv-s2-search"
              type="text"
              placeholder="Search files, columns, values…"
              value={s.s2Search}
              onChange={function (e) {
                self.setState({ s2Search: e.target.value });
              }}
            />
            <select
              className="uv-s2-select"
              value={s.s2Status}
              onChange={function (e) {
                self.setState({ s2Status: e.target.value });
              }}
            >
              <option value="">All Status</option>
              <option value="OK">OK</option>
              <option value="ERROR">Error</option>
              <option value="MISSING">Missing</option>
            </select>
            <button
              className="uv-btn uv-btn-outline"
              onClick={function () {
                self.setState({ s2Search: "", s2Status: "" });
              }}
            >
              Reset
            </button>
            <button
              className="uv-btn uv-btn-outline"
              onClick={function () {
                self.exportCSV();
              }}
            >
              ⬇ Export CSV
            </button>
            <button
              className="uv-btn uv-btn-outline"
              onClick={function () {
                self.doRevalidate();
              }}
            >
              🔄 Re-validate
            </button>
            {self.props.history && (
              <button
                className="uv-btn uv-btn-outline"
                onClick={function () {
                  self.props.history.goBack();
                }}
              >
                ← Back
              </button>
            )}
          </div>

          {/* File cards */}
          <div>
            {filtered.map(function (f, idx) {
              return <S2Card key={idx} f={f} idx={idx} />;
            })}
          </div>

          <div className="uv-s2-footer">
            {d.summary ? d.summary.totalFiles : s.fileResults.length} files ·
            validated at {new Date().toLocaleTimeString()}
          </div>
        </div>
      </div>
    );
  }

  renderScreen3() {
    var s = this.state;
    var cfg = this.cfg;
    var C = 345.4;
    var offset = C - (s.calcPercent / 100) * C;

    return (
      <div className="uv-screen-calc">
        {/* Calc Hero */}
        <div className="uv-calc-hero">
          <div className="uv-calc-hero-inner">
            <div className="uv-calc-spinner"></div>
            <div>
              <div className="uv-calc-title">Calculating…</div>
              <div className="uv-calc-sub">
                {cfg.component} · {cfg.reportDate} · {cfg.reportName}
              </div>
            </div>
            <span
              className="uv-s2-hero-badge"
              style={{
                marginLeft: "auto",
                background: "rgba(37,99,235,.3)",
                color: "#BFDBFE",
                border: "1.5px solid rgba(37,99,235,.4)",
                display: "inline-flex",
                alignItems: "center",
                padding: "8px 18px",
                borderRadius: "24px",
                fontSize: "13px",
                fontWeight: 700,
              }}
            >
              ⏳ Processing…
            </span>
          </div>
        </div>

        <div className="uv-page">
          <div className="uv-panel">
            <div className="uv-panel-header">
              <div className="uv-panel-icon uv-pi-blue">⚙️</div>
              <div>
                <div className="uv-panel-title">Calculation in progress</div>
                <div className="uv-panel-desc">
                  {cfg.component} · Please wait while the report is being
                  generated
                </div>
              </div>
              <div style={{ marginLeft: "auto" }}>
                <span className="uv-badge uv-badge-info">Step 3/4</span>
              </div>
            </div>
            <div className="uv-progress-wrap">
              {/* Ring */}
              <div className="uv-ring-wrap">
                <svg
                  width="120"
                  height="120"
                  viewBox="0 0 120 120"
                  style={{ transform: "rotate(-90deg)" }}
                >
                  <circle className="uv-ring-bg" cx="60" cy="60" r="55" />
                  <circle
                    className="uv-ring-fill"
                    cx="60"
                    cy="60"
                    r="55"
                    style={{ strokeDashoffset: offset, stroke: "#2563EB" }}
                  />
                </svg>
                <div className="uv-ring-center">
                  <span className="uv-ring-pct">{s.calcPercent}%</span>
                  <span className="uv-ring-label">DONE</span>
                </div>
              </div>
              {/* Bar */}
              <div className="uv-bar-wrap">
                <div className="uv-bar-current">
                  <span
                    className="uv-dot-ping"
                    style={{ background: "#2563EB" }}
                  ></span>
                  <span>Running {cfg.component} calculation…</span>
                </div>
                <div className="uv-bar-track">
                  <div
                    className="uv-bar-fill uv-running"
                    style={{
                      width: s.calcPercent + "%",
                      background: "linear-gradient(90deg, #2563EB, #60A5FA)",
                    }}
                  ></div>
                </div>
                <div className="uv-bar-info">
                  <span>Processing report data</span>
                  <span>{s.calcPercent}%</span>
                </div>
              </div>
            </div>
          </div>

          {s.calcStatus === "error" && (
            <div className="uv-panel">
              <div className="uv-panel-header">
                <div className="uv-panel-icon uv-pi-red">❌</div>
                <div>
                  <div className="uv-panel-title">Calculation error</div>
                  <div className="uv-panel-desc">
                    {s.calcError || "An unknown error occurred"}
                  </div>
                </div>
              </div>
              <div className="uv-panel-body">
                <button
                  className="uv-btn uv-btn-yellow"
                  onClick={function () {
                    this.startCalculation();
                  }.bind(this)}
                >
                  🔄 Retry Calculation
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  renderScreen4() {
    var s = this.state;
    var cfg = this.cfg;
    var self = this;

    return (
      <div className="uv-screen-done">
        <div className="uv-done-hero">
          <div className="uv-done-hero-inner">
            <div className="uv-done-icon">🎉</div>
            <div>
              <div className="uv-done-title">Calculation complete!</div>
              <div className="uv-done-sub">
                {cfg.component} · {cfg.reportDate} · {cfg.reportName}
              </div>
            </div>
            <span
              style={{
                marginLeft: "auto",
                background: "rgba(22,135,54,.35)",
                color: "#A7F3D0",
                border: "1.5px solid rgba(22,135,54,.4)",
                display: "inline-flex",
                alignItems: "center",
                padding: "8px 18px",
                borderRadius: "24px",
                fontSize: "13px",
                fontWeight: 700,
              }}
            >
              ✓ Report ready
            </span>
          </div>
        </div>

        <div className="uv-page">
          <div className="uv-panel">
            <div className="uv-panel-header">
              <div className="uv-panel-icon" style={{ background: "#D1FAE5" }}>
                ✅
              </div>
              <div>
                <div className="uv-panel-title">
                  Report generated successfully
                </div>
                <div className="uv-panel-desc">
                  Your {cfg.component} calculation is complete. You can now view
                  the report.
                </div>
              </div>
            </div>
            <div className="uv-panel-body">
              <div className="uv-done-actions">
                {s.reportUrl && (
                  <a
                    href={s.reportUrl}
                    className="uv-btn uv-btn-green"
                    style={{
                      textDecoration: "none",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    📊 View Report
                  </a>
                )}
                <button
                  className="uv-btn uv-btn-outline"
                  onClick={function () {
                    self.doRevalidate();
                  }}
                >
                  🔄 Re-validate
                </button>
                {self.props.history && (
                  <button
                    className="uv-btn uv-btn-outline"
                    onClick={function () {
                      self.props.history.goBack();
                    }}
                  >
                    ← Back
                  </button>
                )}
              </div>
            </div>
          </div>

          <div className="uv-s2-footer">
            {cfg.component} calculation completed at{" "}
            {new Date().toLocaleTimeString()}
          </div>
        </div>
      </div>
    );
  }

  render() {
    var s = this.state;
    var cfg = this.cfg;

    // Step dot helpers
    var dot1 = s.step >= 1 ? (s.step > 1 ? " uv-complete" : " uv-active") : "";
    var dot2 = s.step >= 2 ? (s.step > 2 ? " uv-complete" : " uv-active") : "";
    var dot3 = s.step >= 3 ? (s.step > 3 ? " uv-complete" : " uv-active") : "";
    var dot4 = s.step >= 4 ? " uv-active" : "";

    return (
      <div className="uv-root">
        {/* Topbar */}
        <div className="uv-topbar">
          <div className="uv-ey-mark">EY</div>
          <span className="uv-topbar-title">
            EY –{" "}
            {s.step <= 2
              ? "Validation"
              : s.step === 3
                ? "Calculation"
                : "Report Ready"}
          </span>
          <span className="uv-topbar-sub">{cfg.component}</span>
          <div className="uv-topbar-right">
            <div className="uv-step-row">
              <div className={"uv-step-dot" + dot1}></div>
              <span style={{ fontSize: 11, color: "#aaa" }}>Validate</span>
              <div className={"uv-step-dot" + dot2}></div>
              <span style={{ fontSize: 11, color: "#aaa" }}>Results</span>
              <div className={"uv-step-dot" + dot3}></div>
              <span style={{ fontSize: 11, color: "#aaa" }}>Calculate</span>
              <div className={"uv-step-dot" + dot4}></div>
              <span style={{ fontSize: 11, color: "#aaa" }}>Done</span>
            </div>
          </div>
        </div>

        {s.step <= 2 && this.renderScreen1()}
        {s.step <= 2 && this.renderScreen2()}
        {s.step === 3 && this.renderScreen3()}
        {s.step === 4 && this.renderScreen4()}
        {this.renderToasts()}

        <canvas
          ref={function (el) {
            this._canvasRef = el;
          }.bind(this)}
          style={{
            display: "none",
            position: "fixed",
            inset: 0,
            pointerEvents: "none",
            zIndex: 9999,
          }}
        />
      </div>
    );
  }
}

export default UploadValidate;



// WEBPACK FOOTER //
// src/pages/UploadValidate/index.js